//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionTrash(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.9799 20H8.01994L7.18994 9H5.18994L6.15994 22H17.8399L18.8099 9H16.8099L15.9799 20Z" fill="currentColor" /><path d="M20.4098 4.55L20.0698 2.58L14.9498 3.47L13.9498 2.63L9.08982 3.49L8.43982 4.62L3.31982 5.51L3.66982 7.49L20.4098 4.55Z" fill="currentColor" /></svg>;
}
export default IconActionTrash;